import worker from '../../assets/Images/worker.png'
import { Header, MainButton } from '../../Components/index'
import { Button } from 'antd'
import Geocode from "react-geocode"
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api'
import React, { useEffect, useRef, useState } from 'react'

Geocode.setApiKey("AIzaSyDtZ2MI9NVtHQAJeF4BWYtIXonio-e4lA4")
const containerStyle = {
    width: '100%',
    height: '35vh'
}

const Map = (props) => {
    // const [selectedValue, setSelectedValue] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState("Choisir une option");
    const options = ["20-35m2", "35-50m2", "Plus de 50m2"];

    const handleOptionClick = (option) => {
        setSelectedOption(option);
        let event = option
        let opt
        if (event == '20-35m2') {
            opt = 1
        } else if (event == '35-50m2') {
            opt = 2
        } else if (event == 'Plus de 50m2') {
            opt = 3
        }
        setSelectedValue(
            {
                val: event,
                opt
            }

        )
        setIsOpen(false)
        console.log('selectedValue', event)
    };
    const { setMap, setAddress, setMarker, center, marker, selectedValue, setSelectedValue } = props
    const [map, setMapVal] = React.useState(null)
    const onLoad = React.useCallback(async function callback(map) {
        const bounds = await new window.google.maps.LatLngBounds(center)
        map.fitBounds(bounds)
        setMapVal(map)
    }, [])

    const onUnmount = React.useCallback(function callback(map) {
        setMapVal(null)
    }, [])
    const onMapClick = (e) => {
        setMarker({
            lat: e.latLng.lat(),
            lng: e.latLng.lng()
        })
    }
    const handleDropdownChange = async (event) => {
        event = event?.target?.value
        let opt
        if (event == '20-35m2') {
            opt = 1
        } else if (event == '35-50m2') {
            opt = 2
        } else if (event == 'Plus de 50m2') {
            opt = 3
        }
        setSelectedValue(
            {
                val: event,
                opt
            }

        )
        console.log('selectedValue', event)
    };
    return (
        <>
            <div>
                <Header heading='Simulez votre projet photovoltaique !' />
                <div className='inner_div'>
                    <div className='worker_div' >
                        <img src={worker} className='worker_img' />
                    </div>
                    <div className='section_container'>
                        <div className="section">
                            <div className='step_progress'>
                                <div className='address_step'></div>
                                <div className='address_step'></div>
                                <div className='step'></div>
                                <div className='step'></div>

                            </div>
                            <div className='map_main_div'>
                                <div className='map_text_div'>
                                    <h2>Cliquez sur la toiture de votre logement</h2>
                                    <p>Cette information nous permet d’estimer votre potentiel solaire</p>
                                </div>
                                <div className='iframe_div'>
                                    {center?.lat && center?.lng
                                        ?
                                        <div className='map_div'>
                                            <GoogleMap
                                                // options={function (maps) { return { mapTypeId: "satellite" } }}
                                                mapContainerStyle={containerStyle}
                                                center={center}
                                                zoom={20}
                                                onLoad={onLoad}
                                                onUnmount={onUnmount}
                                                // className='iframe'
                                                options={{ zoomControl: true, mapTypeId: "satellite" }}
                                                onMouseOut={() => { map.panTo(center) }}
                                                onClick={onMapClick}
                                            >
                                                {marker?.lat && marker?.lng &&
                                                    <Marker key={0} position={{ lat: marker?.lat, lng: marker?.lng }} >
                                                    </Marker>}
                                            </GoogleMap>
                                        </div>
                                        : null}
                                    {/* <iframe className='iframe' src="https://maps.google.com/maps?width=100%25&amp;height=262px&amp;hl=en&amp;q=1%20Grafton%20Street,%20Dublin,%20Ireland+(My%20Business%20Name)&amp;t=k&amp;z=19&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.maps.ie/distance-area-calculator.html"></a></iframe> */}
                                </div>
                            </div>
                            <div>

                                <div className='surfaceDe'>
                                    <div className="surfaceDe_heading"> <h1>Quelle est la surface de votre toit ?</h1></div>
                                    <div className="dropdown">
                                        <div className="dropdown-header" onClick={() => setIsOpen(!isOpen)}>
                                            {selectedOption}
                                        </div>
                                        {isOpen && (
                                            <ul className="dropdown-list">
                                                {options?.map((option) => (
                                                    <li key={option} onClick={() => handleOptionClick(option)} className='dropdownli'>
                                                        {option}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>


                            </div>
                            <div className='map_div_btn'>
                                <div className="Button_div" onClick={() => setAddress(false)}>
                                    <Button className='map_btn'>Précédent</Button>
                                </div>
                                <div onClick={() => setMap(true)}>
                                    <MainButton disabled={marker?.lat && marker?.lng ? false : true} title='Suivant' />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Map
